import React, { Component } from "react";
import Header from "./Header";
import HeaderIntro from "./HeaderIntro";
import Footer from "./Footer";
import NewsLetter from "./NewsLetter";
export class PremiumAssistedefiling extends Component {
  render() {
    return (
      <div>
        <Header />
        <HeaderIntro />
        <section id="contact" style={{ backgroundColor: "#f3f9fd" }}>
          <div className="container">
          <div class="container-fluid" data-aos="fade-up">
            
            <div class="section-header">
              <h3>Premium Assisted E-Filing</h3>
              <p>
              ClipTax realizes the significance of transparency, accuracy and
                innovativeness required in the Filing of Income Tax Return. We
                offer you our personal assistance by allocating one of our
                professional to educate and ease out the complicated procedures
                of taxation for you.
              </p>
            </div>
           
          </div>
          </div>
        </section>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default PremiumAssistedefiling;
